import BaseProxy from "../../base-proxy";

export default class GetCompaniesByNameProxy {
  async validateCompanyName(input = {}) {
    const baseProxy = new BaseProxy();
    const backendUrl = await baseProxy.getBackendUrl();
    const endpointUrl = `${backendUrl}/v2/sleek-site-onboarding/find-company?name=${encodeURIComponent(input.name)}`;

    return baseProxy.getAuthenticatedData(endpointUrl, null);
  }

  async validateCompanyNameViaPublicApi(input = {}) {
    // input.publicApiUrl is always 'https://company-checker.sleek.com/company' unless changed
    if (input.publicApiUrl) {
      let endpointUrl = `${input.publicApiUrl}?name=${input.name}`;
      const baseProxy = new BaseProxy();
      return baseProxy.getDataFromSleekAllowedEndpoints(endpointUrl);
    }
  }
}
